import React, { useState } from "react";

import { ErrorMessage, Heading1, PrimaryButton } from "widgets";
import SingleSelect from "widgets/Dropdown/SingleSelect";
import { UPLOAD_SCRIPT_TYPE, SELECTED_SCRIPT_IDS } from "constants/constants";
import { Input } from "@mui/material";
import { useUploadCsv } from "store/backend/apiHooks";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import styles from "./Upload.module.scss";

const handleFileChange = (event, setFile, setFileError) => {
  const selectedFile = event.target.files[0];
  if (!is_valid_file(selectedFile)) {
    setFileError("Invalid file format. Please upload a CSV file.");
  } else {
    setFileError("");
    setFile(selectedFile);
  }
};

const handleSubmit = (
  file,
  selectedScriptId,
  openSnackbar,
  processUploadCsv,
  uploaderUserId
) => {
  processUploadCsv(
    { file, selectedScriptId, uploaderUserId },
    {
      onSuccess: (data) => {
        if (!data) {
          throw new Error("Received data is undefined");
        }
        if (data.uploaded_file_id) {
          openSnackbar(
            `File Uploaded Successfully!`,
            "success"
          );
        }
      },
      onError: (err) => {
        openSnackbar(err.message || "Download failed", "error");
      },
    }
  );
};

const is_valid_file = (file) => {
  if (!file) {
    return false;
  }
  const fileExtension = file.name.split(".").pop().toLowerCase();
  return fileExtension === "csv";
};

const Upload = () => {
  const [file, setFile] = useState(null);
  const [selectedScriptId, setSelectedScriptId] = useState("");
  const [fileError, setFileError] = useState("");
  const [uploaderUserId] = useState(localStorage.getItem("user_id"));

  const { mutate: processUploadCsv, isPending: isUploadPending } =
    useUploadCsv();

  const { openSnackbar } = useSnackbarContext();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.uploadContainer}>
        <div className={styles.action}>
          <Heading1 heading="Choose an action" />
          <SingleSelect
            menuItems={UPLOAD_SCRIPT_TYPE}
            handleChange={(event) =>
              setSelectedScriptId(SELECTED_SCRIPT_IDS[event.target.value])
            }
            selectedValue={selectedScriptId}
          />
        </div>

        {selectedScriptId && (
          <div className={styles.action}>
            <Heading1 heading="Upload File" />
            <div className={styles.input}>
              <Input
                id="file-upload"
                type="file"
                display="none"
                className={styles.inputField}
                onChange={(event) =>
                  handleFileChange(event, setFile, setFileError)
                }
              />
              {file && <p>Selected file: {file.name}</p>}
            </div>
          </div>
        )}
        <div className={styles.button}>
          <PrimaryButton
            onClick={() =>
              handleSubmit(
                file,
                selectedScriptId,
                openSnackbar,
                processUploadCsv,
                uploaderUserId
              )
            }
            disabled={!file || fileError || !selectedScriptId || isUploadPending}
          >
            {isUploadPending ? "Uploading..." : "Upload"}
          </PrimaryButton>
        </div>
        {fileError && <ErrorMessage>{fileError}</ErrorMessage>}
      </div>
    </div>
  );
};

export default Upload;
